"use client";

import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";

export function ContractsCardSkeleton({
  separator = true,
}: {
  separator?: boolean;
}) {
  return (
    <div className="space-y-2">
      <Skeleton className="h-3 w-1/2 sm:w-1/3 md:w-1/4" />

      <div className="flex flex-col md:flex-row md:justify-between gap-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 flex-1 text-sm">
          <div className="flex flex-col gap-1">
            <Skeleton className="h-3 w-2/5 sm:w-1/2" />
            <Skeleton className="h-3 w-full max-w-[160px]" />
          </div>

          <div className="flex flex-col gap-1">
            <Skeleton className="h-3 w-2/5 sm:w-1/2" />
            <Skeleton className="h-3 w-full max-w-[176px]" />
          </div>

          <div className="flex flex-col gap-1">
            <Skeleton className="h-3 w-2/5 sm:w-1/2" />
            <Skeleton className="h-3 w-full max-w-[144px]" />
          </div>

          <div className="flex flex-col gap-1">
            <Skeleton className="h-3 w-2/5 sm:w-1/2" />
            <Skeleton className="h-6 w-full max-w-[112px] rounded-full" />
          </div>
        </div>

        <div className="flex justify-end items-start mt-2 md:mt-0">
          <Skeleton className="h-3 w-16 sm:w-20" />
        </div>
      </div>

      {separator && <Separator />}
    </div>
  );
}

export function ContractsListSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <ContractsCardSkeleton key={i} separator={i !== count - 1} />
      ))}
    </div>
  );
}
